// Footer "Cookie Preferences" button. It opens Shopify's cookie preferences window. It stays hidden until
// Shopify's banner script is ready, so it never shows as a button that does nothing.
// Also: a reload when the visitor withdraws consent (see "Withdrawn consent").

(function () {
  const buttons = document.querySelectorAll('[data-cookie-preferences]');

  function bannerReady() {
    return typeof window.privacyBanner?.showPreferences === 'function';
  }

  function showButtons() {
    if (!bannerReady()) {
      return;
    }
    buttons.forEach((button) => {
      button.hidden = false;
      button.addEventListener('click', () => window.privacyBanner.showPreferences());
    });
  }

  if (buttons.length) {
    // The banner script loads async. The page load event waits for it, so check again then.
    if (bannerReady()) {
      showButtons();
    } else {
      window.addEventListener('load', showButtons, { once: true });
    }
  }

  // Withdrawn consent. Scripts that already run cannot be stopped. So when an allowed category is withdrawn,
  // reload, and the page loads only what the new choice allows. New consent needs no reload:
  // consent-gate.liquid releases those scripts in place.

  function allowedCategories(privacy) {
    return {
      analytics: privacy.analyticsProcessingAllowed(),
      marketing: privacy.marketingAllowed(),
      preferences: privacy.preferencesProcessingAllowed(),
      saleOfData: privacy.saleOfDataAllowed(),
    };
  }

  // svahaConsentReady: see snippets/consent-gate.liquid.
  window.svahaConsentReady?.then((privacy) => {
    let allowed = allowedCategories(privacy);
    document.addEventListener('visitorConsentCollected', () => {
      const now = allowedCategories(privacy);
      if (Object.keys(now).some((category) => allowed[category] && !now[category])) {
        window.location.reload();
        return;
      }
      allowed = now;
    });
  });
})();
